/* eslint-disable lines-around-comment */
import React, { Component } from 'react';
// @ts-ignore
import { createE2EEEvent, sendAnalytics } from '../../analytics';
import { translate } from '../../base/i18n/functions';
import { connect } from '../../base/redux/functions';
import Switch from '../../base/ui/components/web/Switch';
// @ts-ignore
import { toggleE2EE } from '../actions';
// @ts-ignore
import { MAX_MODE } from '../constants';
// @ts-ignore
import { doesEveryoneSupportE2EE } from '../functions';
/**
 * Implements a React {@code Component} for displaying a security dialog section with a field
 * for setting the E2EE key.
 *
 * @augments Component
 */
class E2EESection extends Component {
    /**
     * Implements React's {@link Component#getDerivedStateFromProps()}.
     *
     * @inheritdoc
     */
    static getDerivedStateFromProps(props, state) {
        if (props._toggled !== state.toggled) {
            return {
                toggled: props._toggled
            };
        }
        return null;
    }
    /**
     * Instantiates a new component.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            toggled: false
        };
        // Bind event handlers so they are only bound once for every instance.
        this._onToggle = this._onToggle.bind(this);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _descriptionResource, _enabled, _e2eeLabels, _everyoneSupportE2EE, t } = this.props;
        const { toggled } = this.state;
        const description = (_e2eeLabels === null || _e2eeLabels === void 0 ? void 0 : _e2eeLabels.description) || t(_descriptionResource);
        const label = (_e2eeLabels === null || _e2eeLabels === void 0 ? void 0 : _e2eeLabels.label) || t('dialog.e2eeLabel');
        const warning = (_e2eeLabels === null || _e2eeLabels === void 0 ? void 0 : _e2eeLabels.warning) || t('dialog.e2eeWarning');
        return (React.createElement("div", { id: 'e2ee-section' },
            React.createElement("p", { "aria-live": 'polite', className: 'description', id: 'e2ee-section-description' },
                description,
                !_everyoneSupportE2EE && React.createElement("br", null),
                !_everyoneSupportE2EE && warning),
            React.createElement("div", { className: 'control-row' },
                React.createElement("label", { htmlFor: 'e2ee-section-switch' }, label),
                React.createElement(Switch, { checked: toggled, disabled: !_enabled, id: 'e2ee-section-switch', onChange: this._onToggle }))));
    }
    /**
     * Callback to be invoked when the user toggles E2EE on or off.
     *
     * @private
     * @returns {void}
     */
    _onToggle() {
        const newValue = !this.state.toggled;
        this.setState({
            toggled: newValue
        });
        sendAnalytics(createE2EEEvent(`enabled.${String(newValue)}`));
        this.props.dispatch(toggleE2EE(newValue));
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    const { enabled: e2eeEnabled, maxMode } = state['features/e2ee'];
    const { e2eeLabels } = state['features/base/config'];
    let descriptionResource = '';
    if (e2eeLabels) {
        // When e2eeLabels are present, the descriptionResouse is ignored.
        descriptionResource = undefined;
    }
    else if (maxMode === MAX_MODE.THRESHOLD_EXCEEDED) {
        descriptionResource = 'dialog.e2eeDisabledDueToMaxModeDescription';
    }
    else if (maxMode === MAX_MODE.ENABLED) {
        descriptionResource = e2eeEnabled
            ? 'dialog.e2eeWillDisableDueToMaxModeDescription' : 'dialog.e2eeDisabledDueToMaxModeDescription';
    }
    else {
        descriptionResource = 'dialog.e2eeDescription';
    }
    return {
        _descriptionResource: descriptionResource,
        _e2eeLabels: e2eeLabels,
        _enabled: maxMode === MAX_MODE.DISABLED || e2eeEnabled,
        _toggled: e2eeEnabled,
        _everyoneSupportE2EE: doesEveryoneSupportE2EE(state)
    };
}
export default translate(connect(mapStateToProps)(E2EESection));
